import React from "react";
import "./FooterBarcode.scss";

const FooterBarcode = () => {
  return <div className="bc-container-footer barcode">dstl-Thescienceinside</div>;
};

export default FooterBarcode;
